export const MinisiteSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    aria-hidden="true"
    role="presentation"
    width={24}
    height={24}
  >
    <path
      d="M13,17.71a13.16,13.16,0,0,0,2.17-4.4c1.09-.1,1.95-.21,2.56-.3A8.29,8.29,0,0,1,13,17.71ZM2.31,13c.61.09,1.48.2,2.56.3A13.13,13.13,0,0,0,7,17.71,8.28,8.28,0,0,1,2.31,13ZM7.09,2.27A14,14,0,0,0,4.88,6.69c-1.09.1-2,.21-2.57.3A8.29,8.29,0,0,1,7.09,2.27ZM17.69,7c-.61-.09-1.48-.21-2.57-.3a13.84,13.84,0,0,0-2.21-4.43A8.31,8.31,0,0,1,17.69,7ZM15.42,8c1.27.12,2.2.26,2.68.35A7.78,7.78,0,0,1,18.26,10a7.88,7.88,0,0,1-.16,1.62c-.47.08-1.39.22-2.68.35a12.15,12.15,0,0,0,0-3.93Zm-4.77,4.18V7.78c1.27,0,2.42.07,3.42.14A10.7,10.7,0,0,1,14.28,10a11.47,11.47,0,0,1-.2,2.08C13.08,12.15,11.93,12.2,10.65,12.22ZM9.35,1.77V6.48c-1.13,0-2.15,0-3.06.1a13.2,13.2,0,0,1,2.92-4.8Zm1.44,0a13.08,13.08,0,0,1,2.92,4.81c-.91-.06-1.94-.1-3.06-.11V1.77ZM5.72,10a10.62,10.62,0,0,1,.21-2.08c1-.07,2.14-.12,3.42-.14v4.44c-1.27,0-2.42-.07-3.43-.14A11.56,11.56,0,0,1,5.72,10Zm-4,0A7.88,7.88,0,0,1,1.9,8.38C2.38,8.3,3.29,8.16,4.58,8a12.47,12.47,0,0,0-.16,2,13.56,13.56,0,0,0,.15,2c-1.27-.12-2.19-.26-2.67-.35A7.78,7.78,0,0,1,1.74,10ZM9.2,18.22a12.49,12.49,0,0,1-2.93-4.81c.92.06,2,.1,3.08.11v4.71Zm1.6,0h-.15V13.52c1.14,0,2.16,0,3.08-.11A12.41,12.41,0,0,1,10.8,18.22ZM10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
)
export default MinisiteSvg
